const appendZero = (number) => (number < 10 ? `0${number}` : number);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const getFormattedDate = (date, separator, format) => {
  const newdate = new Date(date);
  const value = {
    DD: appendZero(newdate.getDate()),
    MM: appendZero(newdate.getMonth() + 1),
    YY: appendZero(newdate.getFullYear()),
  };
  return format
    .split(separator)
    .map((field) => value[field])
    .join(separator);
};

export const getDay = (date) => {
  const dayIndex = new Date(date).getDay();
  return days[dayIndex];
};

export const getDate = (date) => {
  const newdate = new Date(date);
  return `${appendZero(newdate.getDate())} ${
    months[newdate.getMonth()]
  }, ${newdate.getFullYear()}`;
};

export function linkifyText(paragraph) {
  const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g;

  return paragraph.replace(urlRegex, (url) => {
    let hyperlink = url;

    // Add http if missing (for www. links)
    if (!hyperlink.startsWith("http")) {
      hyperlink = "http://" + hyperlink;
    }

    return `<a href="${hyperlink}" style="text-decoration:underline" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}
